import { useCallback, useMemo, useState } from "react"
import { useListAgreementVersion } from "interface/agreement"

export const useAgreementManagementContainer = () => {
  const [currentVersion, setCurrentVersion] = useState<number | null>(null)

	const versionListState = useListAgreementVersion()
	const versionList = useMemo(
		() => versionListState.data?.list,
		[versionListState]
	)
	const current = useMemo(
		() => {
			if (versionList && versionList.length > 0) {
				const current = currentVersion ? versionList.find(v => v.version === currentVersion) : undefined
				return current ?? versionList[0]
			}
			return null
		},
		[versionList, currentVersion]
	)
	const reload = useCallback(
		() => {
			setCurrentVersion(null)
			versionListState.refetch()
		},
		[versionListState, setCurrentVersion]
	)
	return useMemo(() => ({
    loading: versionListState.loading,
    error: versionListState.error,
    currentVersion, setCurrentVersion, 
		versionList, current, reload
	}), [
		versionListState,
    currentVersion, setCurrentVersion, 
		versionList, current, reload
	])
}